import styled from 'styled-components';

export const StyledAgentDetail = styled.div`
  .detail-header {
    padding-bottom: 22px;
    border-bottom: 1px solid #eaeaea;
    font-weight: 300;
    font-size: 14px;
    line-height: 18px;
    color: var(--text-color);
    margin-bottom: 20px;
    @media (min-width: 675px) {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .image-wrapper {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      flex-shrink: 0;
      background: #efefef;
      overflow: hidden;
      @media (min-width: 768px) {
        width: 65px;
        height: 65px;
      }
      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }
    .text-wrap {
      color: var(--primary);
      max-width: 180px;
      width: 100%;
    }
    .name {
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      display: block;
      margin-bottom: 5px;
      @media (min-width: 768px) {
        font-size: 24px;
        line-height: 28px;
      }
    }
    .image-text {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 15px;
      margin-bottom: 15px;
      @media (min-width: 675px) {
        margin-bottom: 0;
      }
    }
    .btn-wrap {
      max-width: 165px;
      width: 100%;
    }
    .btn-wrap-two {
      width: 100%;
    }
  }
  .two-wrap {
    display: flex;
    align-items: center;
    max-width: 200px;
    width: 100%;
    gap: 15px;
  }
`;

export const AgentTaskWrapperStyles = styled.div`
  .table-header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .graph-wrap {
    max-width: max-content;
    margin-left: auto;
  }
  .downloadIconWrapper {
    margin-right: 5px;
    max-width: 20px;
    width: 100%;
    margin-left: auto;
  }
  .table-title {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    text-transform: capitalize;
    display: block;
    margin-bottom: 20px;
    color: var(--primary);
  }
`;
